__turbopack_context__.v({
  "actions": "header-module__jszmPq__actions",
  "companiesLink": "header-module__jszmPq__companiesLink",
  "discoveryNav": "header-module__jszmPq__discoveryNav",
  "header": "header-module__jszmPq__header",
  "inner": "header-module__jszmPq__inner",
  "links": "header-module__jszmPq__links",
  "login": "header-module__jszmPq__login",
  "marketplace": "header-module__jszmPq__marketplace",
  "mobileToggle": "header-module__jszmPq__mobileToggle",
  "navigation": "header-module__jszmPq__navigation",
  "register": "header-module__jszmPq__register",
  "rotated": "header-module__jszmPq__rotated",
  "solutionTrigger": "header-module__jszmPq__solutionTrigger",
  "solutions": "header-module__jszmPq__solutions",
  "solutionsList": "header-module__jszmPq__solutionsList",
});
